import { z } from 'zod';
import { PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH } from './password-rules.js';
/**
 * The Reset your password form, opened from the link in a password reset
 * email. Written once here so the dashboard and the API refuse with the same
 * text (`patterns/error-handling.md`, 3).
 *
 * The password is used exactly as typed: never trimmed or case-folded
 * (`patterns/auth-patterns.md`, 1).
 */
export const RESET_PASSWORD_FORM_MESSAGES = {
    passwordTooShort: `Use at least ${PASSWORD_MIN_LENGTH} characters.`,
    passwordTooLong: `Use no more than ${PASSWORD_MAX_LENGTH} characters.`,
    /**
     * The link can't be used: expired, forged, already used, or its Account User
     * was removed. One answer for all of them (`patterns/auth-patterns.md`, 1).
     */
    linkInvalid: "This link can't be used. Ask for a new password reset email.",
};
export const resetPasswordFormSchema = z.object({
    password: z
        .string()
        .min(PASSWORD_MIN_LENGTH, { error: RESET_PASSWORD_FORM_MESSAGES.passwordTooShort })
        .max(PASSWORD_MAX_LENGTH, { error: RESET_PASSWORD_FORM_MESSAGES.passwordTooLong }),
});
/** The token from the link, as it was in the URL. */
const tokenSchema = z.string().min(1, { error: RESET_PASSWORD_FORM_MESSAGES.linkInvalid });
export const passwordResetCheckBodySchema = z.object({ token: tokenSchema });
export const passwordResetBodySchema = resetPasswordFormSchema.extend({ token: tokenSchema });
//# sourceMappingURL=reset-password-form.js.map